module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvZXNwb3J0cy1kZWZhdWx0LWhlYWRlci5iZWNjNGQyZS5wbmciOw=="